export default __webpack_public_path__ + "static/media/fiolet_umnyj-dom.c8ab71a3.svg";